module.exports = __webpack_public_path__ + "images/assets/002e34095fb1442f611a98ddf5a71da1.svg";